import React from 'react';
import { Icon } from '@iconify/react';
import tailwindcssIcon from '@iconify/icons-logos/tailwindcss-icon';
import reactjsIcon from '@iconify/icons-logos/react';
import { HighlightedTextIcon } from 'components/molecules';

const Text = () => (
    <>
        我花了大约两年的时间来提高我在{' '}
        <span className="font-bold text-gray-800">网站开发</span> 方面的技能，使用{' '}
        <HighlightedTextIcon
            as="a"
            href="https://reactjs.org"
            className="mx-2"
            icon={<Icon icon={reactjsIcon} />}
        >
            ReactJS
        </HighlightedTextIcon>{' '}
        和{' '}
        <HighlightedTextIcon className="mx-2" icon={<Icon icon={tailwindcssIcon} />}>
            TailwindCSS
        </HighlightedTextIcon>{' '}
        ，我现在非常有信心使用这些工具构建应用程序：
    </>
);

const skills = {
    text: <Text />,
};

export default skills;
